import { Container } from '@mui/material';
import type { PageProps } from 'gatsby';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import BackgroundIcon from '@components/BackgroundIcon';

import { useSession } from '@hooks/useSession';

import AppLayout from '@layouts/AppLayout';

import AssessmentsMain from '@views/Assessments/Main';
import PatientList from '@views/Dashboard/Assessments/PatientList';
import MainWrapper from '@views/Records/Common/MainWrapper';

const messages = defineMessages({
  bha: {
    id: 'assessmentsMain.bha',
    defaultMessage:
      'Digital Health {count, plural, one {Assessment} other {Assessments}}',
  },
  other: {
    id: 'assessmentsMain.other',
    defaultMessage:
      'Other {count, plural, one {Assessment} other {Assessments}}',
  },
});

export default function AssessmentsPage({ params }: PageProps) {
  const { formatMessage } = useIntl();
  const { type } = params;

  let title = '';
  switch (type) {
    case 'other':
      title = formatMessage(messages.other, {
        count: 10,
      });
      break;
    case 'dha':
    default:
      title = formatMessage(messages.bha, {
        count: 10,
      });
      break;
  }
  const {
    state: { active_user_id, isPractitioner, logged_in_user_id },
  } = useSession();

  const isViewingActivePatient = active_user_id !== logged_in_user_id;

  if (!isViewingActivePatient && isPractitioner) {
    return (
      <AppLayout loading={false} friendlyName={title} showHeader>
        <BackgroundIcon />
        <Container maxWidth="xl">
          <PatientList />
        </Container>
      </AppLayout>
    );
  }

  return (
    <MainWrapper
      backgroundIcon="logo"
      friendlyName={title}
      showBreadcrumb={false}
      showHeader
      title={title}
    >
      <AssessmentsMain assessmentType={type} />
    </MainWrapper>
  );
}
